import styled from "tachyons-components";

export const StyledButton = styled("button")`
f6 link bg-transparent hover-bg-black hover-white br2 ba bw1 ph3 pv2 dib black pointer
`;
